export default __webpack_public_path__ + "static/bg_graphic_flow-d1bfbefaedc154d671215677de8dbaa1.webm";